import { c as _c } from "react/compiler-runtime";
import React, { HTMLAttributes } from "react";
interface SpacerProps extends HTMLAttributes<HTMLSpanElement> {
  size?: number;
  axis?: "horizontal" | "vertical";
  style?: React.CSSProperties;
}
const Spacer: React.FC<SpacerProps> = t0 => {
  const $ = _c(14);
  let delegated;
  let t1;
  let t2;
  let t3;
  if ($[0] !== t0) {
    ({
      size: t1,
      axis: t2,
      style: t3,
      ...delegated
    } = t0);
    $[0] = t0;
    $[1] = delegated;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
  } else {
    delegated = $[1];
    t1 = $[2];
    t2 = $[3];
    t3 = $[4];
  }
  const size = t1 === undefined ? 8 : t1;
  const axis = t2 === undefined ? "vertical" : t2;
  let t4;
  if ($[5] !== t3) {
    t4 = t3 === undefined ? {} : t3;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const style = t4;
  const width = axis === "vertical" ? 1 : size;
  const height = axis === "horizontal" ? 1 : size;
  let t5;
  if ($[7] !== height || $[8] !== style || $[9] !== width) {
    t5 = {
      display: "block",
      width,
      minWidth: width,
      height,
      minHeight: height,
      ...style
    };
    $[7] = height;
    $[8] = style;
    $[9] = width;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== delegated || $[12] !== t5) {
    t6 = <span style={t5} {...delegated} />;
    $[11] = delegated;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  return t6;
};
export default Spacer;